import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { useToggle } from '../lib/hooks';

const SidebarContext = createContext(null);

export function SidebarProvider({ children }) {
  const [sidebarShown, toggleSidebar] = useToggle(true);
  const value = useMemo(() => ({ sidebarShown, toggleSidebar }), [sidebarShown, toggleSidebar]);

  return <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>;
}

SidebarProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useSidebar() {
  return useContext(SidebarContext);
}
